import React from 'react';

import PreviewCompatibleImage from '../PreviewCompatibleImage';

const images = [
  { image: '/img/brands/frontier.png' },
  { image: '/img/brands/varo.png' },
  { image: '/img/brands/prologis.png' },
  { image: '/img/brands/arrt.png' }
];

export default () => (
  <section className="section" style={{ background: '#fff', textAlign: 'center' }}>
    <h2 style={{
      fontSize: '2rem',
      fontWeight: 500
    }}>BRANDS THAT TRUST US</h2>
    <div className="brands-container">
      {images.map((im, i) => (
        <div key={i} className="brands-item">
          <PreviewCompatibleImage imageInfo={im} />
        </div>
      ))}
    </div>
  </section>
);
